module.exports = __webpack_public_path__ + "img/usuario.d506ae93.png";